import { render, staticRenderFns } from "./NewStructureWithdrawal.vue?vue&type=template&id=bf7d45ac&"
import script from "./NewStructureWithdrawal.vue?vue&type=script&lang=js&"
export * from "./NewStructureWithdrawal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports